import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN, MANUFACTURE } = authRoles

const Warehouses = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

export const warehousesModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/warehouses',
    name: 'warehouses',
    component: Warehouses,
    meta: {
      title: 'Almacenes',
      auth: {
        roles: [ADMIN, MANUFACTURE],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
